import { FaHashtag } from "react-icons/fa";
import { MessageServiceChannel } from "models/integration/messageService";
import { UserRole } from "features/User/models";
import BaseResourceTargetTag from "components/Tag/ResourceTargetTag/BaseResourceTargetTag";
import RoleLabelTag from "components/Tag/UserTag/RoleLabelTag";
import useTargetName from "hooks/useTargetName";

interface RecipientTagProps {
  resourceId: MessageServiceChannel["id"]    ;
  resourceType: "MessageServiceChannel" | "User" | "OnboardingJourneyNetworkRelation";
  role?: UserRole;
  remove?: () => void;
  disabled?: boolean;
  loadingLabel?: string | null;
}

export default function RecipientTag({
  resourceId, resourceType, role, remove = () => { }, disabled = false, loadingLabel = "Loading",
}: RecipientTagProps) {
  const { name, role: derivedRole } = useTargetName({ resourceId, resourceType, loadingLabel });
  const effectiveRole = role || derivedRole;

  // Role-based targets render as the avatar-initial chip used in the task grid.
  // Users + channels keep the existing tag — they have real names/icons that
  // RoleLabelTag's role-initial avatar would lose.
  if (resourceType === "OnboardingJourneyNetworkRelation" && effectiveRole) {
    return <RoleLabelTag role={effectiveRole} remove={disabled ? undefined : remove} />;
  }

  const icon = resourceType === "MessageServiceChannel" ? FaHashtag : undefined;
  return (
    <BaseResourceTargetTag name={name} icon={icon} disabled={disabled} roleName={effectiveRole} remove={remove} />
  );
}
